module.exports = __webpack_public_path__ + "static/media/webdesign-services-img9.aecf0162.jpg";